import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField, IconButton, Typography, Paper, Grid, List, ListItem, ListItemText,Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from '../../components/NotificationContext';
import DeleteIcon from '@mui/icons-material/Delete';

const Seasons = () => {
  useAuth();
  const showNotification = useNotification();
  const navigate = useNavigate();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [initialSeasonProducts, setInitialSeasonProducts] = useState([]);
  const [initialSeasonProductIds, setInitialSeasonProductIds] = useState([]);
  const handleBackClick = () => {
    navigate(-1);
  };


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/product`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setProducts(response.data);
      } catch (error) {
        showNotification('Ürünler yüklenemedi', 'error');
      }
    };

    // Sezon ürünlerini de alalım
    const fetchSelectedProducts = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/season-products`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setInitialSeasonProducts(response.data);

      } catch (error) {
        showNotification('Sezon ürünleri yüklenemedi', 'error');
      }
    };

    fetchProducts();
    fetchSelectedProducts();
  }, []);

  const handleSelectProduct = (product) => {
    // Sezon ürünleri ile çakışan bir ürün var mı kontrol et
    if (!selectedProducts.some(p => p.id === product.id)) {
        // Çakışmıyorsa, yeni ürünü seçilen ürünler listesine ekle
        setSelectedProducts(prev => [...prev, product]);
    } else {
        showNotification(`${product.name} zaten seçili!`, 'warning');
    }
};
  const handleRemoveProduct = (id) => {
    setSelectedProducts(prev => prev.filter(p => p.id !== id));
  };

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSaveSeasonProducts = async () => {
    const selectedProductIds = selectedProducts.map(p => p.id);
    const alreadySeasonProductIds = initialSeasonProducts.map(p => p.id);
  
    // Sadece daha önce eklenmemiş ürünleri filtrele
    const newProductIds = selectedProductIds.filter(
      id => !alreadySeasonProductIds.includes(id)
    );
  
    if (newProductIds.length === 0) {
      showNotification('Yeni eklenen sezon ürünü yok', 'info');
      return;
    }
  
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/product/season-product`, {
        productIds: newProductIds
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      showNotification('Sezon ürünleri başarıyla kaydedildi', 'success');
  
      // Kayıt sonrası yeni eklenenleri initial list'e de ekleyelim
      const newlyAddedProducts = selectedProducts.filter(p => newProductIds.includes(p.id));
      setInitialSeasonProducts(prev => [...prev, ...newlyAddedProducts]);
      setInitialSeasonProductIds(prev => [...prev, ...newProductIds]);
  
      // Yeni eklenenleri temizle
      setSelectedProducts([]);
    } catch (error) {
      showNotification('Sezon ürünleri kaydedilemedi', 'error');
    }
  };
const handleDeleteSeasonProduct = async (productId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/product/season-products/${productId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      showNotification('Ürün sezon listesinden kaldırıldı', 'success');
  
      setInitialSeasonProducts(prev => prev.filter(p => p.id !== productId));
      setInitialSeasonProductIds(prev => prev.filter(id => id !== productId));
    } catch (error) {
      showNotification('Ürün silinemedi', 'error');
    }
  };
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid size={{ xs: 12, sm: 10,md:10 }}>
        <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px', backgroundColor: '#ffffff' }}>
          <IconButton onClick={handleBackClick} style={{ marginRight: '10px' }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
            Sezon Ürünleri
          </Typography>

          <TextField
  label="Ürün Ara"
  variant="outlined"
  fullWidth
  margin="normal"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>

{/* Arama Sonuçları */}
{searchTerm && (
  <List>
    {filteredProducts.map((product) => (
      <ListItem
        key={product.id}
        divider
        button
        onClick={() => handleSelectProduct(product)}
        disabled={
          selectedProducts.some(p => p.id === product.id) ||
          initialSeasonProductIds.includes(product.id) // zaten kayıtlıysa disable
        }
      >
        <ListItemText primary={product.name} secondary={`ID: ${product.id}`} />
      </ListItem>
    ))}
  </List>
)}

{/* Yeni Eklenen Sezon Ürünleri */}
{selectedProducts.length > 0 && (
  <>
    <Typography variant="h6" gutterBottom>
      Yeni Sezon Ürünleri (Kaydedilecek)
    </Typography>
    <List>
      {selectedProducts.map((product) => (
        <ListItem key={product.id} divider>
          <ListItemText primary={product.name} />
          <IconButton onClick={() => handleRemoveProduct(product.id)}>
            <DeleteIcon />
          </IconButton>
        </ListItem>
      ))}
    </List>
    <Button variant="contained" color="primary" onClick={handleSaveSeasonProducts}>
      Sezon Ürünlerini Kaydet
    </Button>
  </>
)}

{/* Kayıtlı Sezon Ürünleri */}
{initialSeasonProducts.length > 0 && (
  <>
    <Typography variant="h6" gutterBottom style={{ marginTop: '30px' }}>
      Kayıtlı Sezon Ürünleri
    </Typography>
    <List>
      {initialSeasonProducts.map((product) => (
        <ListItem key={product.id} divider>
          <ListItemText primary={product.name} />
          <IconButton onClick={() => handleDeleteSeasonProduct(product.id)}>
            <DeleteIcon />
          </IconButton>
        </ListItem>
      ))}
    </List>
  </>
)}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Seasons;
